import { isCustomerSuccess } from "lib/utils";
import { getCompany } from "services/company.service";

/**
 * Platform Role users - for now only Customer Success users have no company on GET user (no company_users); merge the active
 * company from GET company by id so themes and slug work.
 */
export const getCompaniesDataForPlatformRole = async (entity, companyId) => {
  if (!entity || !companyId) return entity;
  if (!isCustomerSuccess(entity.roles || [])) return entity;

  const companyRes = await getCompany(companyId);
  if (!companyRes?.status || !companyRes?.entity) return entity;

  const match = companyRes.entity;
  return {
    ...entity,
    company: [{ ...match, userRoles: match.userRoles ?? [] }],
  };
};
